export default __webpack_public_path__ + "css/resetPassword.bundle.css";